import { lazy } from 'react';
import { ProtectedRoute } from '../components/ProtectedRoute';
import PasswordContextProvider from '../contexts/PasswordContext';

const approvingRouteConfig = [
  {
    parent: {
      exact: true,
      path: '/approval',
      element: ProtectedRoute,
      permission_id: 17,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/approving/DocumentApproving')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-AP',
      element: ProtectedRoute,
      permission_id: 41,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/adjusting-entries/DocumentGeneralJournalApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-reversal',
      element: ProtectedRoute,
      permission_id: 48,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/accruals/DocumentAccrualReversalApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-accruals-and-reversals',
      element: ProtectedRoute,
      permission_id: 85,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-accrual-reversal/DocumentGeneralJournalAccrualsReversalsApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-treasury-12',
      element: ProtectedRoute,
      permission_id: 49,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-treasury/DocumentGeneralJournalTreasuryApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-treasury-22',
      element: ProtectedRoute,
      permission_id: 87,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-treasury/DocumentGeneralJournalTreasuryApproving22.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-cost-and-budget-12',
      element: ProtectedRoute,
      permission_id: 50,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-cost-and-budget/DocumentGeneralJournalCostAndBudgetApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-cost-and-budget-22',
      element: ProtectedRoute,
      permission_id: 76,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-cost-and-budget/DocumentGeneralJournalCostAndBudgetApproving22.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-cost-and-budget-30',
      element: ProtectedRoute,
      permission_id: 77,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-cost-and-budget/DocumentGeneralJournalCostAndBudgetApproving30.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-fixed-asset-12',
      element: ProtectedRoute,
      permission_id: 51,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-fixed-asset/DocumentGeneralJournalFixedAssetApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-fixed-asset-22',
      element: ProtectedRoute,
      permission_id: 75,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-fixed-asset/DocumentGeneralJournalFixedAssetApproving22.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-confidential-12',
      element: ProtectedRoute,
      permission_id: 52,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-confidential/DocumentGeneralJournalConfidentialApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-confidential-22',
      element: ProtectedRoute,
      permission_id: 79,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-confidential/DocumentGeneralJournalConfidentialApproving22.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-confidential-30',
      element: ProtectedRoute,
      permission_id: 98,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-confidential/DocumentGeneralJournalConfidentialApproving30.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-sales',
      element: ProtectedRoute,
      permission_id: 54,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-sales/DocumentGeneralJournalSalesApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-FO',
      element: ProtectedRoute,
      permission_id: 55,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-FO/DocumentGeneralJournalFOApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-FO',
      element: ProtectedRoute,
      permission_id: 56,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-live/DocumentGeneralJournalLiveApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-live',
      element: ProtectedRoute,
      permission_id: 56,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-live/DocumentGeneralJournalLiveApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-AR',
      element: ProtectedRoute,
      permission_id: 61,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-AR/DocumentGeneralJournalARApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-ap-specialist-12',
      element: ProtectedRoute,
      permission_id: 68,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-specialist/DocumentGeneralJournalAPSpecialistApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-ap-specialist-22',
      element: ProtectedRoute,
      permission_id: 68,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-specialist/DocumentGeneralJournalAPSpecialist22Approving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/general-journal-pcf',
      element: ProtectedRoute,
      permission_id: 69,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-PCF/DocumentGeneralJournalPCFApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/approval/cheque-cancellation',
      element: ProtectedRoute,
      permission_id: 39,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/approval of cheque-cancellation/DocumentChequeCancellationApproval.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
    {
    parent: {
      exact: true,
      path: '/approval/general-journal-year-end',
      element: ProtectedRoute,
      permission_id: 100,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-year-end/DocumentGeneralJournalYearEndApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
     {
    parent: {
      exact: true,
      path: '/approval/general-journal-confidential-year-end',
      element: ProtectedRoute,
      permission_id: 102,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general-journal-approving/gj-confidential-year-end/DocumentGeneralJournalConfidentialYearEndApproving.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
];

export default approvingRouteConfig;
